angular.module('satv.track')

    .factory('Track', ['config', '$resource', function (config, $resource) {
        return $resource(config.apiUri + '/tracks/:id', {
            id: '@id'
        }, {
            query: {
                isArray: false
            },
            update: {
                method: 'PATCH'
            }
        });
    }])

    .factory('TrackLoader', ['Track', 'LoaderFactory', function (Track, LoaderFactory) {
        return function (params) {
            return new LoaderFactory(Track, params, {'resultSet': 'data', 'totalResultCount': 'totalFound'});
        };
    }])

;



// WEBPACK FOOTER //
// ./vendor/sonyatv/smfcoreclientbundle/Resources/js/angular/services/Track.js